/**
 * Aide contextuelle : page de l'aide intégrée (/aide) correspondant à l'écran affiché.
 * Les chemins sont ceux du portail docs-site (docs/**). Une page non autorisée pour l'utilisateur
 * affiche « Page réservée » dans l'aide ; l'accueil de l'aide est utilisé par défaut.
 */
const BY_ROUTE_NAME = {
  dashboard: '/guide-utilisateur/tableau-de-bord',
  projects: '/guide-utilisateur/projets',
  'team-management': '/guide-utilisateur/equipe',
  profile: '/guide-utilisateur/profil-parametres',
  settings: '/guide-utilisateur/profil-parametres',
  resources: '/guide-utilisateur/ressources',
  planning: '/guide-utilisateur/planning-mensuel',
  'planning-global': '/guide-utilisateur/planning-global',
  'planning-tracking': '/guide-utilisateur/suivi-planning',
  budget: '/guide-utilisateur/budget',
  personnel: '/guide-utilisateur/personnel',
  'personnel-report': '/guide-utilisateur/personnel',
  'poste-reconciliation': '/guide-utilisateur/personnel',
  'activity-report': '/guide-utilisateur/performance-activites',
  feedback: '/guide-utilisateur/feedback',
  materiel: '/guide-utilisateur/materiel',
  'materiel-reconciliation': '/guide-utilisateur/materiel',
  'materiel-report': '/guide-utilisateur/materiel',
  'budget-control': '/guide-utilisateur/controle-budgetaire',
  reallocation: '/guide-utilisateur/controle-budgetaire',
  'activity-liquidity': '/guide-utilisateur/activite-liquidite',
  'daily-expense-reports': '/guide-utilisateur/rapports-depenses',
  notifications: '/guide-utilisateur/notifications',
  'site-reports-overview': '/guide-utilisateur/validation-chantier',
  'site-reports-validation': '/guide-utilisateur/validation-chantier',
  'site-report-view': '/guide-utilisateur/validation-chantier',
  'site-reports': '/guide-utilisateur/rapports-chantier',
  'site-reports-create': '/guide-utilisateur/rapports-chantier',
  'site-reports-edit': '/guide-utilisateur/rapports-chantier',
  'pointeur-photos': '/guide-utilisateur/rapports-chantier#photos-chantier',
  'qhse-pays': '/guide-utilisateur/qhse',
  'admin-dashboard': '/administration/console',
  'admin-users': '/administration/utilisateurs',
  'admin-user-profile': '/administration/utilisateurs',
  'admin-permissions': '/administration/roles-permissions',
  'admin-ai-settings': '/administration/ia',
  'admin-fuel-config': '/administration/parametres#carburant',
  'admin-budget-control-config': '/administration/parametres#controle-budgetaire',
  'admin-branding': '/administration/parametres#identite',
  'admin-general-settings': '/administration/parametres#generaux',
  'admin-system': '/administration/systeme',
  'admin-audit-logs': '/administration/audit',
  'admin-feedback': '/administration/systeme#retours-utilisateurs',
  'admin-email-settings': '/administration/emails-notifications',
  'admin-notification-settings': '/administration/emails-notifications#rappels-automatiques',
  'admin-send-notifications': '/administration/emails-notifications#envoyer-une-notification',
}

/** Onglets de la fiche projet (?tab=…) ayant leur propre page d'aide. */
const PROJECT_TABS = {
  'cost-studies': '/guide-utilisateur/etudes-de-prix',
  versions: '/guide-utilisateur/versions',
  sections: '/guide-utilisateur/projet-structure',
  activities: '/guide-utilisateur/projet-structure',
  overview: '/guide-utilisateur/projet-structure',
}

/** Chemin de l'aide pour une route Vue Router. */
export function helpPathFor(route) {
  if (route?.name === 'project-detail') {
    return PROJECT_TABS[route.query?.tab] || (route.query?.tab ? '/guide-utilisateur/projet-suivi' : '/guide-utilisateur/projet-structure')
  }
  return BY_ROUTE_NAME[route?.name] || '/'
}

/** Lien de l'application qui ouvre l'aide (voir pages/DocumentationRedirect.vue). */
export function helpHrefFor(route) {
  return `/documentation?to=${encodeURIComponent(helpPathFor(route))}`
}
